import React from 'react';
import { cn } from '../../lib/utils';
import { BRAND_NAME } from '../../lib/brand';

const SIZE_CLASS = {
  nav: 'brand-wordmark-nav',
  inline: 'brand-wordmark-inline',
  sm: 'brand-wordmark-sm',
  md: 'brand-wordmark-md',
  lg: 'brand-wordmark-lg',
  hero: 'brand-wordmark-hero',
  footer: 'brand-wordmark-footer',
};

const BrandWordmark = ({ size = 'nav', className, as: Component = 'span', ...props }) => (
  <Component className={cn('brand-wordmark', SIZE_CLASS[size], className)} {...props}>
    {BRAND_NAME}
  </Component>
);

export default BrandWordmark;
